import { render } from "./DlcCard.vue?vue&type=template&id=a761e678"
import script from "./DlcCard.vue?vue&type=script&lang=js"
export * from "./DlcCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__